/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoAnalyticsModelsWidgetListItem
 */
export interface MelcoAnalyticsModelsWidgetListItem {
    /**
     * 
     * @type {string}
     * @memberof MelcoAnalyticsModelsWidgetListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoAnalyticsModelsWidgetListItem
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoAnalyticsModelsWidgetListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoAnalyticsModelsWidgetListItem
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoAnalyticsModelsWidgetListItem
     */
    url?: string | null;
}

export function MelcoAnalyticsModelsWidgetListItemFromJSON(json: any): MelcoAnalyticsModelsWidgetListItem {
    return MelcoAnalyticsModelsWidgetListItemFromJSONTyped(json, false);
}

export function MelcoAnalyticsModelsWidgetListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoAnalyticsModelsWidgetListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function MelcoAnalyticsModelsWidgetListItemToJSON(value?: MelcoAnalyticsModelsWidgetListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'type': value.type,
        'url': value.url,
    };
}


